import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Fade } from 'react-reveal';
import { Section } from '@/features/new-landing-page/components/section';
import { StrapiTextual } from '@/features/strapi/components/textual';
import { FeaturesContent } from '@/features/new-landing-page/pages/homepage-content';
import { VSpace } from '@/components/spacing';
import { StrapiFeatureCard } from '@/features/strapi/components/feature-card';
import { StrapiImageTextual } from '@/features/strapi/components/image-textual';

export function FeaturesSection() {
  const rows = useMemo(
    () =>
      FeaturesContent.features.reduce((acc, feature, index) => {
        const row = Math.floor(index / 2);
        if (!acc[row]) {
          acc[row] = [];
        }
        acc[row].push(feature);
        return acc;
      }, [] as any[][]),
    [],
  );

  return (
    <Section>
      <VSpace value={8} mobileValue={4} />
      <StrapiTextual {...FeaturesContent.title} mobileMultiplier={0.6} />
      <VSpace value={4} />
      <FeatureWrapper className="only-desktop">
        {rows.map((row) => (
          <Fade bottom key={row.map((r) => r.text).join(`-`)}>
            <Row>
              {row.map((feature) => (
                <StrapiFeatureCard key={feature.text} {...feature} />
              ))}
            </Row>
          </Fade>
        ))}
      </FeatureWrapper>
      <MobileFeatureWrapper className="only-mobile">
        {FeaturesContent.features.map((feature) => (
          <div className="full-width" key={feature.title.text}>
            <Fade bottom>
              <StrapiFeatureCard {...feature} width="90%" />
            </Fade>
            <VSpace value={2} />
          </div>
        ))}
      </MobileFeatureWrapper>
      <VSpace value={4} mobileValue={1} />
      <StrapiImageTextual {...FeaturesContent.footer} />
      <VSpace value={4} mobileValue={3} />
    </Section>
  );
}

const FeatureWrapper = styled.div`
  display: grid;
  grid-gap: 4rem;
`;

const MobileFeatureWrapper = styled.div`
  display: grid;
  align-content: center;
  align-items: center;
  justify-items: center;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4rem;
`;
